import React from 'react'
import TextField from './TextField'
import { Grid } from '@material-ui/core'
import language from 'utils/vast-languagepack'

export default () => (
  <Grid item xs={12}>
    <TextField
      property="backgroundColor"
      label={language.signupform.add.labels.backgroundColor}
      placeholder="#ffffff"
      color
    />
  </Grid>
)
